var Reverb = window.Reverb || {};

Reverb.S3Uploader = (function () {
  function init(formSelector) {
    bindS3UploadForm(formSelector);
  }

  function bindS3UploadForm(formSelector) {
    $(formSelector).each(function () {
      var form = $(this);
      var callbackUrl = form.data('callback');
      var statusContainer = form.find('[data-bind=\'s3-upload-form-status-container\']');
      var uploadInProgress = form.find('[data-bind=\'s3-upload-form-progress\']');
      var uploadSuccessMessage = form.find('[data-bind=\'s3-upload-form-success\']');
      var uploadFailureMessage = form.find('[data-bind=\'s3-upload-form-failure\']');
      var uploadHardFailureMessage = form.find('[data-bind=\'s3-upload-form-hard-failure\']');
      var fileUploadInput = form.find('[data-bind=\'s3-upload-form-input\']');
      var invalidFileTypeMessage = form.find('[data-bind=\'s3-upload-form-incorrect-file-type\']');

      form.fileupload({
        autoUpload: true,
        dataType: 'xml',
        add: function (event, data) {
          injectS3Policy(data, form);
          data.submit();
        },
        send: function () {
          statusContainer.fadeIn();
          fileUploadInput.fadeOut();
          uploadInProgress.fadeIn();
        },
        done: function (event, data) {
          // Custom event required to register callbacks on done.
          $(form).trigger('done');

          var fileUrl = $(data.result).find('Location').text();
          var fileExtension = fileUrl.split('.').pop();
          uploadInProgress.hide();
          if (isEmpty(fileUrl)) {
            statusContainer.removeClass('alert-success');
            statusContainer.addClass('alert-error');
            uploadFailureMessage.fadeIn();
          } else if (incorrectFileType(fileExtension)) {
            statusContainer.removeClass('alert-success');
            statusContainer.addClass('alert-error');
            invalidFileTypeMessage.fadeIn();
          } else {
            onUploadComplete(fileUrl, callbackUrl).done(function () {
              uploadSuccessMessage.fadeIn();
            }).error(function () {
              uploadHardFailureMessage.fadeIn();
            });
          }
        }
      });
    });
  }

  function incorrectFileType(fileExtension) {
    return (fileExtension !== 'csv');
  }

  function isEmpty(str) {
    return (!str || 0 === str.length);
  }

  function injectS3Policy(data, form) {
    $.ajax({
      url: '/s3_policy',
      type: 'POST',
      dataType: 'json',
      data: {
        doc: {
          type: data.files[0].type,
          title: data.files[0].name
        }
      },
      async: false,
      success: function (response) {
        form.find('input[name=key]').val(response.key);
        form.find('input[name=policy]').val(response.policy);
        form.find('input[name=signature]').val(response.signature);
        form.find('input[name=AWSAccessKeyId]').val(response.aws_access_key_id);
        form.find('input[name=x-amz-security-token]').val(response.aws_session_token);
      }
    });
  }


  // When the S3 upload completes, it will invoke this callback so that we can notify our backend
  // and do any additional actions on the uploaded file.
  function onUploadComplete(fileUrl, callbackUrl) {
    return $.ajax({
      url: callbackUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        url: fileUrl
      }
    });
  }

  return {
    init: init
  };
})();

$(document).ready(function () {
  Reverb.S3Uploader.init('[data-bind=\'s3-upload-form\']');
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/s3_uploader.js